export default __webpack_public_path__ + "static/media/East.cb3bdc0d.png";